import React from 'react';

const Categories = () => (
  <div>
    <p>
      Under construction
    </p>
  </div>
);
export default Categories;
